export default {
  apply: {
    en: 'Apply Bonus',
  },
  freebet: {
    en: 'Freebet',
  },
}
